// extracted by mini-css-extract-plugin
module.exports = {"narrowSearchBanner":"styles_narrowSearchBanner__DuFvi","iconAndTitleContainer":"styles_iconAndTitleContainer__sgTl5","icon":"styles_icon__2Qyfq","title":"styles_title__kr_zk"};